var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("div", { staticClass: "dashboard-page-title" }, [
      _c("div", { staticClass: "container-fluid" }, [
        _c("h1", [_vm._v(_vm._s(_vm.$t("Client")) + " List")]),
      ]),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "container-fluid" },
      [
        _c("div", { staticClass: "dashboard-results-details" }, [
          _c("div", { staticClass: "row" }, [
            _c(
              "div",
              { staticClass: "col-xs-12 col-sm-4" },
              [
                _c(
                  "router-link",
                  {
                    staticClass: "btn btn-sm btn btn-primary",
                    attrs: { to: { name: "clients.create" } },
                  },
                  [
                    _c("i", { staticClass: "fa fa-plus" }),
                    _vm._v(" Add Client"),
                  ]
                ),
              ],
              1
            ),
          ]),
        ]),
        _vm._v(" "),
        _c(
          "user-list-filters",
          {
            staticClass: "margin-y-1",
            attrs: {
              "set-filter-mutation": _vm.setFilter,
              filters: _vm.filters,
              "apply-filters": _vm.handleApplyFiltersCallback,
              "show-region-filter": _vm.$userIsGlobalAdmin,
            },
          },
          [
            _c(
              "ladda-button",
              {
                staticClass: "btn btn-primary pull-right",
                attrs: {
                  slot: "button",
                  click: _vm.handleApplyFiltersCallback,
                  type: "submit",
                },
                slot: "button",
              },
              [_vm._v("\n        Search\n      ")]
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "dashboard-block" },
          [
            _c(
              "ul",
              {
                staticClass: "nav nav-tabs",
                attrs: { id: "myTabs", role: "tablist" },
              },
              [
                _c(
                  "li",
                  { class: _vm.classForStatus("all") },
                  [
                    _c(
                      "router-link",
                      {
                        attrs: {
                          to: {
                            params: { status: "all" },
                            query: _vm.$route.query,
                          },
                        },
                      },
                      [
                        _vm._v(
                          "All (" + _vm._s(_vm.clientsCounts.all || 0) + ")"
                        ),
                      ]
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "li",
                  { class: _vm.classForStatus("active") },
                  [
                    _c(
                      "router-link",
                      {
                        attrs: {
                          to: {
                            params: { status: "active" },
                            query: _vm.$route.query,
                          },
                        },
                      },
                      [
                        _vm._v(
                          "Active (" +
                            _vm._s(_vm.clientsCounts.active || 0) +
                            ")"
                        ),
                      ]
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "li",
                  { class: _vm.classForStatus("unverified") },
                  [
                    _c(
                      "router-link",
                      {
                        attrs: {
                          to: {
                            params: { status: "unverified" },
                            query: _vm.$route.query,
                          },
                        },
                      },
                      [
                        _vm._v(
                          "Unverified (" +
                            _vm._s(_vm.clientsCounts.unverified || 0) +
                            ")"
                        ),
                      ]
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "li",
                  { class: _vm.classForStatus("trash") },
                  [
                    _c(
                      "router-link",
                      {
                        attrs: {
                          to: {
                            params: { status: "trash" },
                            query: _vm.$route.query,
                          },
                        },
                      },
                      [_c("i", { staticClass: "fa fa-trash" })]
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _vm.$route.params.status === "unverified" &&
                !_vm.filters.keywords
                  ? _c(
                      "li",
                      { staticClass: "ml-auto text-right" },
                      [
                        _c(
                          "ladda-button",
                          {
                            staticClass: "btn btn-primary",
                            attrs: {
                              slot: "button",
                              click: _vm.handleSendActivationEmail,
                              type: "submit",
                            },
                            slot: "button",
                          },
                          [
                            _vm._v(
                              "\n            Send Activation Email\n          "
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c("span", { staticClass: "help-block" }, [
                          _vm._v(
                            "This will notify all users who have not responded within the 24 hour period."
                          ),
                        ]),
                      ],
                      1
                    )
                  : _vm._e(),
              ]
            ),
            _vm._v(" "),
            _vm.fetchingClients
              ? _c("pickstar-loading", { staticClass: "m-t-lg" })
              : _vm.haveNoClients
              ? _c("no-results", [
                  _vm._v("\n        There are no clients.\n      "),
                ])
              : _c(
                  "ul",
                  { staticClass: "item-detail item-detail-profile" },
                  _vm._l(_vm.clients, function (client) {
                    return _c("client-list-item", {
                      key: client.id,
                      attrs: { client: client },
                    })
                  }),
                  1
                ),
            _vm._v(" "),
            _c(
              "lazy-loading",
              {
                ref: "lazyLoading",
                staticClass: "text-center",
                attrs: {
                  loading: _vm.loading,
                  "reached-bottom": _vm.handleGetNextClientsCallback,
                },
              },
              [
                _c("pickstar-loading", {
                  attrs: { slot: "loading" },
                  slot: "loading",
                }),
                _vm._v(" "),
                _c("span", { attrs: { slot: "finished" }, slot: "finished" }),
              ],
              1
            ),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }